export default __webpack_public_path__ + "static/media/aviso_home.c4522301.jpeg";